import { Container, PointerEvents } from '@tencent/alloy-renderer';
import { InterfaceFactoryOptions } from './factory-options.interface';
import { TableBackgroundComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/table/table-background-component';
import { TableBackgroundFillComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/table/table-background-fill-component';
import { TableBorderComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/table/table-border-component';
import { TableComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/table/table-component';
import { CANVAS_TABLE_ID_PREFIX } from '@src/slide/content-viewer/service/canvas-renderer/core/id-constants';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';


export class RendererTableComponent extends Container {
    private readonly factoryOptions: InterfaceFactoryOptions<ITableModel>;

    private tableBackground: TableBackgroundComponent | null;
    private TableBackgroundFillComponent: TableBackgroundFillComponent | null;
    private tableBorder: TableBorderComponent | null;
    private tableCells: TableComponent | null;

    private tableEditable = true;

    public constructor(factoryOptions: InterfaceFactoryOptions<ITableModel>) {
        super();
        this.factoryOptions = factoryOptions;
        const { model } = this.factoryOptions;
        this.id = `${CANVAS_TABLE_ID_PREFIX}-${model.key}`;

        this.TableBackgroundFillComponent = new TableBackgroundFillComponent(this.factoryOptions);
        this.TableBackgroundFillComponent.pointerEvents = PointerEvents.NONE;
        this.addChild(this.TableBackgroundFillComponent);

        // 只负责渲染，事件在logic单独绑定
        this.tableBackground = new TableBackgroundComponent();
        this.tableBackground.pointerEvents = PointerEvents.NONE;
        this.addChild(this.tableBackground);

        this.tableCells = new TableComponent(this.factoryOptions);
        this.addChild(this.tableCells);

        this.tableBorder = new TableBorderComponent(this.factoryOptions);
        this.tableBorder.pointerEvents = PointerEvents.NONE;
        this.addChild(this.tableBorder);

        this.updateComponent(true);
    }

    public updateTextEditorCursor(cursor: string): void {
        this.tableCells?.updateTextEditorCursor(cursor);
    }

    public updateComponent = (forceUpdate: boolean): void => {
        const { model, region, isEditable, modelParams } = this.factoryOptions;
        const tableState = modelParams?.updateState?.tableState;
        const isEditStateChange = isEditable !== this.tableEditable;
        if (forceUpdate || tableState?.shouldUpdate || isEditStateChange) {
            this.TableBackgroundFillComponent?.updateModel(model);
            this.tableBackground?.updateModel(model);
            this.tableCells?.updateModel(model);
            this.tableBorder?.updateModel(model.tableBorders);
        }
        this.tableEditable = isEditable || false;

        model.cleanStateForRegion?.(region);
    };

    public getTableBackgroundComponent(): TableBackgroundComponent | null {
        return this.tableBackground;
    }

    public dispose(): void {
        super.dispose();

        this.TableBackgroundFillComponent?.dispose();
        this.tableBackground?.dispose();
        this.tableCells?.dispose();
        this.tableBorder?.dispose();
    }
}
